module.exports = __webpack_public_path__ + "/login_ui/img/tc-7b50ba7f0ad69205a173d2462bad1cf1.svg";